import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, FormField, Text,
} from '@domain-group/suit-theme'

import copyToClipboard from '@functions/copyToClipboard'

import type { BulkShareArtworksPayload } from '@hooks/useBulkShareArtworks'

interface PublicLinkProps {
  bulkShareArtworksPayload: BulkShareArtworksPayload,
}

const PublicLink = (props: PublicLinkProps) => {
  const {
    bulkShareArtworksPayload: {
      artworkReviewUrls: { publicUrl },
    },
  } = props

  return (
    <FormField direction="column" label="Share Public Link" style={{ marginTop: 32 }}>
      <Text color="bodyFontLightColor" fontSize="xsmall" lineHeight="1.3" marginTop="small">
        Artworks will be available to view by anyone who has access to this link. Users will not be able to leave
        comments.
      </Text>

      <Box marginTop="large">
        <input readOnly value={publicUrl} type="email" />

        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faClipboard} />}
          // @ts-expect-error
          marginLeft="medium"
          onClick={() => copyToClipboard(publicUrl)}
          size="medium"
          width="auto"
        />
      </Box>
    </FormField>
  )
}

export default PublicLink
